import { Component, Output, EventEmitter, Input, OnChanges, OnInit } from '@angular/core';
import { UserJobsService } from '../user-jobs.service';
import { TranslateService } from '@ngx-translate/core';
import { BzgToastService, BzgModalRef, BzgModalService } from 'bz-genome-angular';
import { EJobType } from 'app/scheduler/jobs/job-type.enum';
import * as _ from 'lodash';
import { SavePendingChangesComponent } from '../../../shared/components/save-pending-changes/save-pending-changes.component';
import { IUserJob } from 'app/scheduler/core/IUserJob';

@Component({
    selector: 'user-jobs-description',
    templateUrl: 'user-jobs-description.component.html',
    styleUrls: ['user-jobs-description.component.scss']
})
export class UserJobsDescriptionComponent implements OnChanges {
    @Input() currentUserJob: IUserJob;
    @Output() cancel = new EventEmitter();
    @Output() resetEmit = new EventEmitter();
    @Output() userJobUpdate = new EventEmitter();

    public jobType: EJobType = EJobType.User;
    public modalRef: BzgModalRef;
    public job: IUserJob;

    constructor(private _userJobService: UserJobsService,
        private _translateService: TranslateService,
        private _toastService: BzgToastService,
        private _modalService: BzgModalService) { }

    ngOnChanges() {
        this.job = _.cloneDeep(this.currentUserJob);
    }

    public async validatePendingChanges() {
        const isDateDifferent = new Date(this.currentUserJob.nextRuntime).getTime() !== new Date(this.job.nextRuntime).getTime();
        const isEnabledDifferent = this.currentUserJob.enabled !== this.job.enabled;

        if (isDateDifferent || isEnabledDifferent) {
            this.modalRef = this._modalService.open(SavePendingChangesComponent, {closeOnRouterNavigation: true});
            this.modalRef.afterClosed().subscribe(result => {
                switch (result.action) {
                    case 'cancel':
                        this.modalRef.close();
                        break;
                    case 'dontsave':
                        this.modalRef.close();
                        this.cancelAction();
                        break;
                    case 'save':
                        this.saveUserJob(this.job, true)
                        this.modalRef.close();
                        break;
                    case 'close':
                        this.modalRef.close();
                        break;
                }
            });
        } else {
            this.cancelAction();
        }
    }

    public async saveUserJob(userJob: any, closeAfter = false) {
        this._userJobService.update(userJob).subscribe((response) => {
            this.currentUserJob = userJob;
            this.userJobUpdate.emit(this.currentUserJob);
            if (closeAfter) {
                this.cancelAction();
            }
            this._translateService.get('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY').subscribe((message: string) => {
                this._toastService.open(
                    message,
                    {
                        type: 'success',
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'right'
                    });
            });
        }, (error) => {
            this._translateService.get('GLOBAL.AN_ERROR_HAS_OCCURRED').subscribe((message: string) => {
                this._toastService.open(
                    message,
                    {
                        type: 'error',
                        duration: 0,
                        verticalPosition: 'top',
                        horizontalPosition: 'right'
                    });
            });

        });
    }

    public cancelAction() {
        this.cancel.emit();
    }

    public reset() {
        this.resetEmit.emit();
    }
}
